import { Button } from 'antd'
import { DocumentUpload } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { UploadMedia } from './UploadMedia'

type Props = {
  broker: number
}

export const AddMediaButton = ({ broker }: Props) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const toggleModal = () => setIsOpen((prev) => !prev)

  return (
    <>
      <Button icon={<DocumentUpload />} type="primary" onClick={toggleModal}>
        {t('upload_file')}
      </Button>

      <UploadMedia
        open={isOpen}
        broker={broker}
        onCancel={toggleModal}
        onSuccess={toggleModal}
      />
    </>
  )
}
